import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import HomeSliderServices from '../../services/HomeSliderServices';
function AddHomeSlider() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    title: '',
    description: '',
    sequence: '1',
    image: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); // Placeholder image path



  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };
  //   // Handle form submission
  const handleSubmit = async (event) => {
    // console.log('ajaj',formValues);
    event.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }

      await HomeSliderServices.createHomeSlider(formData);
      alert('Home slider created successfully');
      navigate('/home-slider');

    } catch (error) {
      console.error('Failed to create home slider', error);
      alert('Failed to create home slider');
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">
              Home Slider Banner Add
            </h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Home Slider Banner Add
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
            <Link className="list-banner-btn" to="/home-slider">List Home Slider</Link>


          </div>
        </div>


        <div className="container-box">

          <div className="container-box-inner table-reponsive-tabe">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="input-field">
                  <label>Tittle<span className="red">*</span></label>
                  <input type="text" name="title" value={formValues.title}
                    onChange={handleInputChange} placeholder='New Title' defaultValue="Product scanning" className="form-control" />
                </div>
                <div className="input-field">
                  <label>
                    Description <span className="red">*</span>
                  </label>

                  <textarea
                    name="description"
                    value={formValues.description}
                    onChange={handleInputChange}
                    placeholder="Enter description"
                    className="form-control"
                    rows="2"             
                  />
                </div>
                <div className='row'>
                  <div className="col-lg-12 col-md-12">
                    <div className="input-field">
                      <label>Select Sequence</label>
                      <select className="form-control" value={formValues.sequence}
                        onChange={handleInputChange} name="sequence">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                      </select>
                    </div>
                  </div>
                </div>


                <div className="input-field">
                  <label>Upload<span className="red">*</span></label>
                  <input type="file" name="image" className="form-control" onChange={handleFileChange}  />
                  <p><span>Drop an image or Paste URL (up to resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>
                </div>
                <button className="submit-green-btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddHomeSlider